import {
  createEffect,
  createMemo,
  createSignal,
  //@ts-ignore
  Show,
  createSelector,
  //@ts-ignore
  For,
  onCleanup,
  onMount,
} from "solid-js";
import { useLocation, useNavigate } from "@solidjs/router";
import { View, ElementNode, hexColor } from "@lightningtv/solid";
import { useFocusManager, useAnnouncer, useMouse } from "@lightningtv/solid/primitives";
import SplashScreen from "./splashScreen/SplashScreen";
import { isProxyHealthDialogOpen, setIsProxyHealthDialogOpen } from "../../state";
import ProxyHealthMessage from "./proxyHealth/ProxyHealthDialog";
import UpdateModal from "../components/UpdateModal";

declare module "@lightningtv/solid/primitives" {
  interface KeyMap {
    Announcer: (string | number)[];
    Menu: (string | number)[];
    // Escape: (string | number)[];
    Backspace: (string | number)[];
  }
}

declare global {
  interface Window {
    //@ts-ignore
    APP: ElementNode;
  }
}

const App = props => {
  const [isSplashVisible, setSplashVisible] = createSignal(true);
  const [useRCU, setUseRCU] = createSignal(false);


  createEffect(() => {
    function getWebOSVersion() {
      // Try newer API (webOS 5.0+)
      webOS.service.request("luna://com.webos.service.tv.systemproperty", {
        method: "getSystemInfo",
        parameters: {
          keys: ["sdkVersion"],
        },
        onSuccess: function (res: any) {
          if (res.sdkVersion) {
            processVersion(res.sdkVersion);
          } else {
            fallbackToLegacyVersion();
          }
        },
        onFailure: function () {
          fallbackToLegacyVersion();
        },
      });

      function fallbackToLegacyVersion() {
        webOS.service.request("luna://com.webos.service.tv.systemproperty", {
          method: "getSystemInfo",
          parameters: {
            key: "sdkVersion",
          },
          onSuccess: function (res: any) {
            if (res.sdkVersion) {
              processVersion(res.sdkVersion);
            } else {
              console.log("SDK version not available (fallback). Using RCU.");
              setUseRCU(true);
            }
          },
          onFailure: function (err: any) {
            console.log("Both version detection methods failed:", err);
            setUseRCU(true);
          },
        });
      }

      function processVersion(sdkVersion: string) {
        const major = parseInt(sdkVersion.split(".")[0]);
        if (isNaN(major)) {
          console.log("Invalid SDK version format. Using RCU.");
          setUseRCU(true);
          return;
        }

        console.log("webOS SDK Version:", sdkVersion, "Major:", major);

        if (major <= 5) {
          setUseRCU(true);
        } else {
          setUseRCU(false);
        }
      }
    }

    getWebOSVersion();
  }, []);


  const keyy = createMemo(() => useRCU() ? 'RCUBack' : 'GoBack');


  createEffect(() => {
    useFocusManager({
      Announcer: ["a"],
      Menu: ["m"],
      Escape: [keyy(), 461],
      // Escape: ["XF86Back", 10009],
      Backspace: ["Backspace", 8],
      Left: ["ArrowLeft", 37],
      Right: ["ArrowRight", 39],
      Up: ["ArrowUp", 38],
      Down: ["ArrowDown", 40],
      Enter: ["Enter", 13],
    });
  });


  // useFocusManager(
  //   {
  //     Announcer: ["a"],
  //     Menu: ["m"],
  //     Escape: ["XF86Back", 10009],
  //     Backspace: ["Backspace", 8],
  //     Back: ["b"],
  //     Left: ["ArrowLeft", 37],
  //     Right: ["ArrowRight", 39],
  //     Up: ["ArrowUp", 38],
  //     Down: ["ArrowDown", 40],
  //     Enter: ["Enter", 13]
  //   } as unknown as KeyMap,
  //   {
  //     userKeyHoldMap: {
  //       EnterHold: ["Enter", 13],
  //       BackHold: ["b", 66]
  //     } as unknown as KeyHoldMap,
  //     holdThreshold: 1000
  //   }
  // );



  useMouse();
  const navigate = useNavigate();
  const announcer = useAnnouncer();
  announcer.debug = false;
  announcer.enabled = false;
  const location = useLocation();


  createEffect(() => {
    const handleSplashEnd = () => {
      setSplashVisible(false);
    };
    setTimeout(handleSplashEnd, 7000);
  }, []);

  return (
    <>
      {isSplashVisible() ? (
        <View color={hexColor("#000000")}>
          <View x={600} y={300}>
            <SplashScreen />
          </View>
        </View>
      ) : (
        <View
          //@ts-ignore
          ref={window.APP}
          onAnnouncer={() => (announcer.enabled = !announcer.enabled)}
          onLast={() => history.back()}
        // onEnter={() => navigate("/text")}
        // onMenu={() => navigate("/")}
        >
          <View />
          {props.children}

          <ProxyHealthMessage
            isProxyHealthDialogOpen={isProxyHealthDialogOpen}
            setIsProxyHealthDialogOpen={setIsProxyHealthDialogOpen}
          />
          {/* <UpdateModal /> */}
        </View>
      )}
    </>
  );
};

export default App;